import OtherProject from "@/views/OtherProject";

export default [
  {
    path: "other/project/:id",
    name: "OtherProject",
    component: OtherProject,
    permission: "gongfu.api.fuwu_admin.projects.show",
    meta: {
      title: "极客-服务中心-项目预览"
    }
  }
];
